import { createServerFn } from "@tanstack/react-start";
import { supabaseAdmin } from "@/integrations/supabase/client.server";

export type PublicCityRow = {
  slug: string;
  name: string;
  region: string | null;
  tagline: string | null;
  image_url: string | null;
  accent: string | null;
  population: string | null;
  founded: number | null;
  lat: number | null;
  lng: number | null;
};

/**
 * Public, SSR-safe fetch of active cities — used by route loaders so the raw
 * HTML response contains real city data (no "Loading cities…" empty shell)
 * and a populated ItemList for AI crawlers.
 */
export const getPublicCities = createServerFn({ method: "GET" }).handler(
  async (): Promise<PublicCityRow[]> => {
    const { data, error } = await supabaseAdmin
      .from("cities")
      .select("slug, name, region, tagline, image_url, accent, population, founded, lat, lng, sort_order, active")
      .eq("active", true)
      .order("sort_order", { ascending: true })
      .order("name", { ascending: true });
    if (error || !data) return [];
    return data.map((c: any) => ({
      slug: c.slug,
      name: c.name,
      region: c.region ?? null,
      tagline: c.tagline ?? null,
      image_url: c.image_url ?? null,
      accent: c.accent ?? null,
      population: c.population ?? null,
      founded: c.founded ?? null,
      lat: c.lat ?? null,
      lng: c.lng ?? null,
    }));
  },
);
